<template lang="html">
	<div class="inner-modal">
		<div class="head-modal row">
			<div class="inner-header-title column">
				<div class="head-modal-title">
					Ajouter un document
				</div>
				<div class="head-modal-emphase">
					Envoyez des documents à votre conseiller
				</div>
			</div>
			<div class="ctn-custom-label">
				<label>Type de document</label>
				<custom-select v-model="type" :selected="type" :solo="true" :items="docTypeList" />
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui default-form-ui">
				<div class="ctn-form-element">
					<div class="ctn-input ctn-label" v-inputUI>
						<label for="name">Nom du document</label>
						<input v-validate="'required'" type="text" name="name" v-model="name">
					</div>
				</div>
				<div class="check-container row" v-if="type === 'Autres Documents'">
					<radio-box :value="confidential" @change="confidential=$event"/>
					<div class="link">
						Voulez vous que votre document soit privé
					</div>
				</div>
				<drag-and-drop v-model="file" />
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="confirm">Enregistrer</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import DragAndDrop from '@/common/components/Form/DragAndDrop'
import CustomSelect from '@/common/components/Form/CustomSelect'
export default {
	name: 'AddDocumentModal',
	props: ['data'],
	components: {
		CustomSelect,
		DragAndDrop
	},
	data () {
		return {
			type: 'Autres Documents',
			docTypeList: [
				'Autres Documents',
				'Mes Justificatifs d\'identité',
				'Mes opérations',
				'Abonnements',
				'Paysages patrimoniaux'
			],
			name: null,
			file: null,
			docToAPI: {
				'Autres Documents': 'autre',
				'Mes Justificatifs d\'identité': 'justificatifs',
				'Mes opérations': 'operations',
				'Abonnements': 'subscriptions',
				'Paysages patrimoniaux': 'personal-estate'
			},
			confidential: false
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		confirm () {
			let docType = this.resolveType(this.file.type)
			if (docType) {
				this.$store.dispatch('addDocument', {
					user_id: this.user.id,
					category: this.docToAPI[this.type],
					type: docType,
					confidential: ((this.type === 'Autres Documents') ? this.confidential : false) ? 1 : 0,
					file: this.file,
					subcategory: null,
					signature_required: false,
					signature_token: null,
					original_name: this.name + '.' + docType
				}).then(() => {
					this.$emit('close')
				}).catch((error) => {
					console.log('Error from add document : ', error)
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez vérifier que votre document n\'est pas corrompu'
					})
				})
			} else {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Extension de fichier non reconnue',
					text: 'Les extensions autorisées sont : txt, pdf, doc, docx, xls, xslx'
				})
			}
		},
		resolveType (t) {
			let value = null
			switch (t) {
			case 'application/pdf':
				value = 'pdf'
				break
			case 'application/octet-stream':
				value = 'txt'
				break
			case 'application/msword':
				value = 'doc'
				break
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
				value = 'docx'
				break
			case 'application/vnd.ms-excel':
				value = 'xls'
				break
			case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
				value = 'xlsx'
				break
			default:
				value = false
			}

			return value
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="scss" scoped>
	.inner-modal {
		width: 550px;
	}

	.check-container {
		justify-content: flex-start;
		margin-bottom: 1rem;
		.link {
			margin-left: 0.5rem;
			color: #797979;
			text-decoration: none;
		}
	}

	.inner-header-title {
		width: 100%;
		align-items: flex-start;
	}

	.ctn-custom-label {
		flex-shrink: 0;

		label {
			font-size: 0.8rem;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/modal/AddDocument.vue